export const MAX_SCHEDULED_TASKS = 3;

export const isAtActiveScheduleCap = (activeCount: number) =>
  activeCount >= MAX_SCHEDULED_TASKS;
